import React from "react";

const QuickReply = (props) => {
  
  if (props.reply.structValue.fields.listItem) {
      return (<li>{props.reply.structValue.fields.listItem.stringValue}</li>);
  }
  else
   if (props.reply.structValue.fields.payload) {
    return (
      // <a
      //   style={{ margin: 3,backgroundColor:"#eeeeee" }}
      //   href="/"
      //   className="collection-item"
      //   onClick={(event) =>
      //     props.click(
      //       event,
      //       props.reply.structValue.fields.payload.stringValue,
      //       props.reply.structValue.fields.text.stringValue
      //     )
      //   }
      // >
      //   {props.reply.structValue.fields.text.stringValue}
      // </a>
      <button style={{ margin: 3 , textAlign:"left"}}  onClick={(event) =>
        props.click(
          event,
          props.reply.structValue.fields.payload.stringValue,
          props.reply.structValue.fields.text.stringValue
        )
      }>{props.reply.structValue.fields.text.stringValue}</button>
    );
  } else {
    return (
      <a
        style={{ margin: 3,backgroundColor:"#eeeeee"}}
        href={props.reply.structValue.fields.link.stringValue}
        className="collection-item"
      >
        {props.reply.structValue.fields.text.stringValue}
      </a>
    );
  }
};

export default QuickReply;
